import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type PutTimeSettingsInput, putTimeSettings } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";

export function useSaveTimeSettings() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: (input: PutTimeSettingsInput) =>
			putTimeSettings(activeCanteiroId as string, input),
		onSuccess: (settings) => {
			queryClient.setQueryData(["time-settings", activeCanteiroId], settings);
			queryClient.invalidateQueries({ queryKey: ["time-entries"] });
			queryClient.invalidateQueries({ queryKey: ["timesheet"] });
		},
	});
}
